<div class="modal-header">
  <div class="modal-title h5" id="modalTitle">Custom user mapping</div>
  <button type="button" class="close" (click)="activeModal.close()" aria-label="Close modal?"><span aria-hidden="true">&times;</span></button>
</div>
<div class="modal-body">
  @if (errorMessage) {
  <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
    <coso-alert-message>
      <div class="d-inline" [innerHTML]="errorMessage"></div>
    </coso-alert-message>
  </alert>
  }
  <p>
    Please select the SharePoint user(s) to be associate with the Dynamics 365 user <strong>{{ userMappingToEdit.name }}</strong
    >.
  </p>
  <ul class="list-unstyled">
    <li><strong class="mr-2">ID</strong>{{ userMappingToEdit.crmId }}</li>
    <li><strong class="mr-2">Login</strong> {{ userMappingToEdit.loginName }}</li>
  </ul>
  <div class="ag-grid-scrollable">
    <coso-grid [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowData]="users" [searchable]="true"></coso-grid>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.close()">Cancel</button>
  <button class="btn btn-primary" (click)="save()">Save</button>
</div>
